import React from 'react';
import {HubSpotForm} from 'components/ContentPagesComponents/HubSpotForm';
import {SampleModal} from 'components/ContentPagesComponents/SampleReport/SampleModal';
import {navigate} from 'gatsby';
import {useToggle} from 'hooks/useToggle';

import {AddToCalendarModal} from './AddToCalendarModal';

type Action =
	| 'internal'
	| 'external'
	| 'hubspot'
	| 'report'
	| 'calendar'
;

type Validator = (content: string) => boolean;

const validConfigs: Record<Action, Validator> = {
	internal: (content): boolean => {
		return content.startsWith('/') || content.includes('www.bodyspec.com');
	},
	external: (content): boolean => {
		return !content.startsWith('/') && !content.includes('www.bodyspec.com');
	},
	hubspot: (content): boolean => {
		const validID = new RegExp('^.{8}-.{4}-.{4}-.{4}-.{12}$');
		return validID.test(content);
	},
	report: (content): boolean => {
		/*
		const validID = new RegExp('^[0-9a-z]{32}$');
		return validID.test(content);
		*/

		// placeholder, we currently open the sample report modal whenever
		// the actionBtnConfig starts with 'report', regardless of the content
		// after the pipe character
		return content !== '';
	},
	calendar: (content): boolean => {
		// open add to calendar link whenever the actionBtnConfig starts with 'calendar'
		// regardless of the content after the pipe character
		return content !== '';
	},
};

type Result = {
	valid: boolean
	render?: React.ReactNode
	onClick?: () => void
}

export const useConfig = (config: string): Result => {
	const {open, toggle} = useToggle(false);

	const parts = config.trim().split('|');
	if (parts.length !== 2 && parts[0] !== 'hubspot') {
		if (parts.length === 3 && parts[2] === 'tab') {
			// special case for override to open any link in a new tab
			// e.g. 'external|https://www.bodyspec.com|tab'
			return {
				valid: true,
				render: null,
				onClick: () => window.open(parts[1], '_blank')
			};
		}
		return {valid: false};
	}

	const action = parts[0] as Action;
	const validator = validConfigs[action];
	if (!validator(parts[1])) {
		return {valid: false};
	}

	let onClick = toggle;
	let render: React.ReactNode = null;
	switch (action) {
	case 'hubspot': {
		const Form = HubSpotForm(parts[1], parts[2]);
		render = open && <Form show={true} onClose={toggle} />;
		break;
	}
	case 'report': {
		render = open && <SampleModal onHide={toggle} />;
		break;
	}
	case 'internal': {
		onClick = () => navigate(parts[1]);
		break;
	}
	case 'external': {
		onClick = () => window.open(parts[1], '_blank');
		break;
	}
	case 'calendar': {
		render = open && <AddToCalendarModal onHide={toggle} />;
	}};

	return {
		valid: true,
		render,
		onClick,
	};
};

